import type InvoiceAdjustment from '~/types/InvoiceAdjustment';

import { ActionKeys } from './constants';

export const fetchInvoiceAdjustmentsOfInvoice = (invoiceId: string) =>
  <const>{
    payload: { invoiceId },
    type: ActionKeys.DISPLAY_INVOICE_ADJUSTMENTS_FETCH,
  };

export const fetchInvoiceAdjustmentsOfInvoiceSuccess = (invoiceAdjustments: InvoiceAdjustment[]) =>
  <const>{
    payload: {
      invoiceAdjustments,
    },
    type: ActionKeys.DISPLAY_INVOICE_ADJUSTMENTS_FETCH_SUCCESS,
  };

export const fetchInvoiceAdjustmentsOfInvoiceError = (err: string) =>
  <const>{
    payload: { err },
    type: ActionKeys.DISPLAY_INVOICE_ADJUSTMENTS_FETCH_ERROR,
  };

export type InvoiceAdjustmentActions =
  | ReturnType<typeof fetchInvoiceAdjustmentsOfInvoice>
  | ReturnType<typeof fetchInvoiceAdjustmentsOfInvoiceError>
  | ReturnType<typeof fetchInvoiceAdjustmentsOfInvoiceSuccess>;
